import React from 'react';
import './unauth-head.styles.scss';
import { Link, useNavigate } from 'react-router-dom';
import BrandLogo from '@/components/SHARED/brand-logo/brand-logo.component';

const UnauthHeader = () => {

    const navigate = useNavigate();

    return (
        <div className='unauth-head-container'>
            <div className="g-container">
                <div className='unauth-head'>
                    <div className='logo-div'>
                        <Link to='/' aria-label='Home'><BrandLogo theme='hardwood' /></Link>
                    </div>
                    <div className="links-div">
                        <Link to="/how-it-works" className='head-link'>How it works</Link>
                        <Link to="/signin" className='g-button small-btn primary'>Sign In</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnauthHeader